import React from "react";
import TargetTypeNameField from "../TargetTypeNameField";

function GroupNameField({ group, setGroup }) {
    const onChange = (value) => setGroup({ ...group, name: value, base: false });

    return (
        <TargetTypeNameField
            value={group.name}
            onValueChange={onChange}
            label="Name"
        />
    );
}

export default GroupNameField;
